import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

import { BRAND_DETAILS_FRAGMENT } from '../../../brand-curation-tasks/graphql/fragments'

const MENU_CURATION_TASK_LIST_FRAGMENT = gql`
  fragment MenuCurationTaskListFragment on MenuCurationTask {
    id
    taskStatus
    curationDetailLevel
    awaitingStatus
    lastManualUpdateAt
    updatedAt
    reopenedAt
    createdAt
    curatedAt
    qadAt
    curatedUnknownWordCount
    qadUnknownWordCount
    totalUnknownWordCount
    isReopenedManually
    isUnknownWordsQaDone
    isAvailableForTierOne
    isAvailableForUnknownWordsCuration
    isAvailableForUnknownWordsQa
    isAvailableForCuration
    isAvailableForQa
    isAvailableForQc
    tags

    languages {
      isSuggestedByAi
      language {
        id
        name
      }
    }

    menu {
      id
      autoeatId
      status
      isFake
      dishCount
      locationCount
      autoeatUpdatedAt
      autoeatUpdateAppliedAt
      brand {
        ...BrandDetailsFragment
      }
    }

    assignedTierOneCurator {
      ...SimpleUserFragment
    }

    assignedCurator {
      ...SimpleUserFragment
    }

    assignedQa {
      ...SimpleUserFragment
    }

    assignedUnknownWordsCurator {
      ...SimpleUserFragment
    }

    assignedUnknownWordsQa {
      ...SimpleUserFragment
    }

    assignedQc {
      ...SimpleUserFragment
    }

    assignedScrapingReviewerUser {
      ...SimpleUserFragment
    }

    priorityTaskAllocations {
      id
      priorityTask {
        id
        name
        allocationType
        isDone
      }
      allocatedUser {
        ...SimpleUserFragment
      }
      allocatedRole
      allocatedDishCount
      isDone
    }
  }
  ${SIMPLE_USER_FRAGMENT}
  ${BRAND_DETAILS_FRAGMENT}
`

export default MENU_CURATION_TASK_LIST_FRAGMENT
